module.exports = __webpack_public_path__ + "img/pennellata-curva.3ae10641.png";